var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "kcc-new-center" }, [
    _c(
      "div",
      { staticClass: "news-container border-normal" },
      [
        _c("div", { staticClass: "flex item-center mb-10" }, [
          _c("img", { attrs: { src: require("@/assets/img/icon-news.svg") } }),
          _c("div", { staticClass: "font-bold ml-10" }, [
            _vm._v(_vm._s(_vm.$t("newsMgt.title1"))),
          ]),
        ]),
        _c(
          "el-carousel",
          { attrs: { arrow: "never", autoplay: false } },
          _vm._l(_vm.newsList, function (item) {
            return _c("el-carousel-item", { key: item.id }, [
              _c("div", { staticClass: "flex" }, [
                item.newsImage
                  ? _c("img", {
                      staticClass: "news-pic",
                      attrs: { src: `data:image/png;base64,${item.newsImage}` },
                    })
                  : _vm._e(),
                _c("div", { staticClass: "ml-10" }, [
                  _c("p", { staticClass: "font-bold mb-10" }, [
                    _vm._v(_vm._s(item.newsTitle)),
                  ]),
                  _c("p", { staticClass: "news-desc" }, [
                    _vm._v(_vm._s(item.newsDesc)),
                  ]),
                ]),
              ]),
              _c(
                "a",
                {
                  staticClass: "new-link",
                  on: {
                    click: function ($event) {
                      return _vm.toOuterLink(item.linkUrl)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "mr-5",
                    attrs: { src: require("@/assets/img/icon-link.svg") },
                  }),
                  _c("span", { staticClass: "link-title" }, [
                    _vm._v(_vm._s(item.linkText)),
                  ]),
                ]
              ),
            ])
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "onboard-container" },
      [
        _c("div", { staticClass: "flex item-center mb-10" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/icon-onboard.svg") },
          }),
          _c("div", { staticClass: "font-bold ml-10" }, [
            _vm._v(_vm._s(_vm.$t("newsMgt.title2"))),
          ]),
        ]),
        _c("div", { staticClass: "mb-10" }, [
          _vm._v(_vm._s(_vm.$t("newsMgt.videoIntroduction"))),
        ]),
        _c("div", { staticClass: "flex bottom-splitLine" }, [
          _c("div", { staticClass: "border-normal mr-10 flex p-15 w-50" }, [
            _c("img", {
              staticClass: "mr-10 video-fill",
              attrs: { src: require("@/assets/img/icon-video-fill.svg") },
            }),
            _c("div", [
              _c("div", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("newsMgt.videoList.introduction")) +
                    "\n                    "
                ),
              ]),
              _c(
                "a",
                {
                  staticClass: "onboard-link",
                  on: {
                    click: function ($event) {
                      return _vm.toOuterLink(_vm.video_En)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.en")))]
              ),
              _c(
                "a",
                {
                  staticClass: "onboard-link",
                  on: {
                    click: function ($event) {
                      return _vm.toOuterLink(_vm.video_Cn)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.cn")))]
              ),
              _c(
                "a",
                {
                  staticClass: "onboard-link",
                  on: {
                    click: function ($event) {
                      return _vm.toOuterLink(_vm.video_yueyu)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.yueyu")))]
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "border-normal flex p-15 flex-1 pointer",
              on: {
                click: function ($event) {
                  return _vm.toOuterLink(_vm.video_title)
                },
              },
            },
            [
              _c("img", {
                staticClass: "mr-10 video-fill",
                attrs: { src: require("@/assets/img/icon-video-fill.svg") },
              }),
              _c("div", [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("newsMgt.videoList.newlyLaunched"))),
                ]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "mb-10 mt-10" }, [
          _vm._v(_vm._s(_vm.$t("newsMgt.materials"))),
        ]),
        _c(
          "el-carousel",
          { attrs: { arrow: "always", autoplay: false } },
          _vm._l(_vm.materialsList, function (item, index) {
            return _c("el-carousel-item", { key: index }, [
              _c(
                "div",
                { staticClass: "flex" },
                _vm._l(item, function (child) {
                  return _c(
                    "div",
                    {
                      key: child.id,
                      staticClass: "w-32 pointer",
                      on: {
                        click: function ($event) {
                          return _vm.toOuterLink(child.linkUrl)
                        },
                      },
                    },
                    [
                      child.materialImage
                        ? _c("img", {
                            staticClass: "w-full material-pic",
                            attrs: {
                              src: `data:image/png;base64,${child.materialImage}`,
                            },
                          })
                        : _vm._e(),
                      _c("p", { staticClass: "material-title" }, [
                        _vm._v(_vm._s(child.materialTitle)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          }),
          1
        ),
        _c(
          "div",
          {
            staticClass: "learning-course pointer",
            on: {
              click: function ($event) {
                return _vm.toOuterLink(_vm.eLearningUrl)
              },
            },
          },
          [
            _c("img", {
              staticClass: "mr-10",
              attrs: { src: require("@/assets/img/icon-elearning.svg") },
            }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("newsMgt.learningCourse")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "training-container flex" }, [
      _c("div", { staticClass: "document-container" }, [
        _c("div", { staticClass: "flex item-center mb-5" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/icon-communicate.svg") },
          }),
          _c("div", { staticClass: "font-bold ml-10" }, [
            _vm._v(_vm._s(_vm.$t("newsMgt.title3"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "document-list" },
          _vm._l(_vm.documentList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "doc-title",
                on: {
                  click: function ($event) {
                    return _vm.toOuterLink(item.hyperlink)
                  },
                },
              },
              [
                _c("svg-icon", {
                  staticClass: "mr-10",
                  attrs: {
                    iconName: _vm.renderFileType(item.docName),
                    size: "16",
                  },
                }),
                _vm._v(
                  "\n                " + _vm._s(item.docName) + "\n            "
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "code-view" }, [
        _c("img", {
          staticClass: "qr-code",
          attrs: {
            src: _vm.$i18n.locale === "en" ? _vm.qrCodeEn : _vm.qrCodeCn,
          },
        }),
        _c("div", { staticClass: "font-bold" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("newsMgt.title4")) +
              "\n            "
          ),
        ]),
        _c("p", [_vm._v(_vm._s(_vm.$t("newsMgt.scanTips")))]),
        _c("img", {
          staticClass: "code-handle",
          attrs: { src: require("@/assets/img/icon-overview-phone.png") },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }